import { render, staticRenderFns } from "./collapsible.vue?vue&type=template&id=b8912dc8"
import script from "./collapsible.vue?vue&type=script&lang=js"
export * from "./collapsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports